export const MAX_URLS_COUNT = 5;
export const MAX_TITLES_COUNT = 10;
export const MAX_VERTICAL_TITLES_COUNT = 1;

export const MIN_THUMBNAILS_COUNT = 3;
export const MAX_THUMBNAILS_COUNT = 10;
export const MAX_VERTICAL_THUMBNAILS_COUNT = 1;
export const MEDIA_COLUMN_COUNT = 3;
